<div class="h-full flex flex-col text-slate-800 w-[90vw] sm:w-[400px] max-w-[400px] bg-(--stela-surface)">
    <!-- Header -->
    <div class="header p-4 border-b border-gray-200 flex justify-between items-center bg-gray-50">
        <div class="flex items-center gap-2">
            <p-button *ngIf="view() === 'chat'" icon="pi pi-arrow-left" [rounded]="true" [text]="true"
                styleClass="text-gray-500 hover:text-gray-900 mr-2" (onClick)="toggleView()"></p-button>
            <p-button *ngIf="view() === 'metrics'" icon="pi pi-arrow-left" [rounded]="true" [text]="true"
                styleClass="text-gray-500 hover:text-gray-900 mr-2" (onClick)="backFromMetrics()"></p-button>
            <div *ngIf="view() === 'list'" class="flex items-center gap-2">
                <i class="pi pi-bolt text-blue-500"></i>
                <span class="font-bold text-lg text-slate-900">STELIA</span>
            </div>
            <div *ngIf="view() === 'metrics'" class="flex items-center gap-2">
                <i class="pi pi-chart-line text-blue-500"></i>
                <span class="font-bold text-lg text-slate-900">Métricas IA</span>
            </div>
            <span *ngIf="view() === 'chat'" class="font-bold text-lg truncate max-w-[200px] text-slate-900">
                {{ chatService.activeSession()?.title || 'Chat' }}
            </span>
        </div>
        <p-button icon="pi pi-times" [rounded]="true" [text]="true" styleClass="text-gray-500 hover:text-gray-900"
            (onClick)="close()"></p-button>
    </div>

    <!-- Anchor banner: a qué está anclada la conversación. Una sesión que edita sin decir qué edita es una trampa. -->
    @if (view() === 'chat' && anchorLabel()) {
    <p-message severity="info" icon="pi pi-file-edit" size="small" styleClass="w-full rounded-none!">{{ 'chat.editing_mailing' | translate }}</p-message>
    }

    <!-- List View -->
    <div *ngIf="view() === 'list'" class="flex-1 overflow-y-auto p-4 space-y-4 bg-(--stela-surface)">
        <p-button class="block" label="Nuevo Chat" icon="pi pi-plus" styleClass="w-full p-button-outlined" [outlined]="true"
            (onClick)="startNewChat()"></p-button>
        <p-button class="block" *ngIf="canViewMetrics" label="Ver métricas" icon="pi pi-chart-line"
            styleClass="w-full p-button-text border border-gray-200" [text]="true" (onClick)="openMetrics()">
        </p-button>

        <div class="space-y-2">
            @for (session of chatService.sessions(); track session.id) {
            <div
                class="p-3 bg-(--stela-surface) rounded-lg cursor-pointer hover:bg-gray-50 flex justify-between items-center group transition-colors border border-gray-200 hover:border-blue-300"
                [class.border-blue-500]="session.id === chatService.activeSessionId()"
                [class.bg-blue-50]="session.id === chatService.activeSessionId()" (click)="selectSession(session.id)">
                <div class="truncate flex-1 pr-2">
                    <div class="font-semibold text-sm text-slate-800 truncate">{{ session.title }}</div>
                    <div class="text-xs text-slate-500">{{ session.updatedAt | date:'MM/dd HH:mm' }}</div>
                </div>
                <button
                    class="p-2 text-gray-400 hover:text-red-500 opacity-0 group-hover:opacity-100 transition-opacity"
                    (click)="deleteSession($event, session.id)">
                    <i class="pi pi-trash"></i>
                </button>
            </div>
            }
        </div>
    </div>

    <!-- Metrics View -->
    <div *ngIf="view() === 'metrics'" class="flex-1 overflow-y-auto p-4 space-y-4 bg-(--stela-surface)">
        <div class="flex justify-end">
            <p-button label="Recargar" icon="pi pi-refresh" size="small" [text]="true" [loading]="metricsLoading()"
                (onClick)="loadMetrics()"></p-button>
        </div>

        <p-message size="small" *ngIf="metricsError()" severity="error" styleClass="w-full">{{ metricsError() }}</p-message>

        <div *ngIf="metricsLoading() && !metrics()" class="text-sm text-gray-500">
            Cargando métricas...
        </div>

        <ng-container *ngIf="metrics() as m">
            <div class="grid grid-cols-1 gap-4">
                <div class="rounded-lg border border-gray-200 p-3 bg-gray-50">
                    <div class="text-xs uppercase tracking-wide text-gray-500">Diario</div>
                    <div class="mt-2 text-sm text-slate-700">Votos: <b>{{ m.daily.totalVotes }}</b></div>
                    <div class="text-sm text-green-700">Likes: <b>{{ m.daily.likes }}</b></div>
                    <div class="text-sm text-red-700">Dislikes: <b>{{ m.daily.dislikes }}</b></div>
                    <div class="text-sm text-blue-700">Aprobación: <b>{{ m.daily.approvalRate | number:'1.0-1' }}%</b>
                    </div>
                </div>

                <div class="rounded-lg border border-gray-200 p-3 bg-gray-50">
                    <div class="text-xs uppercase tracking-wide text-gray-500">Semanal</div>
                    <div class="mt-2 text-sm text-slate-700">Votos: <b>{{ m.weekly.totalVotes }}</b></div>
                    <div class="text-sm text-green-700">Likes: <b>{{ m.weekly.likes }}</b></div>
                    <div class="text-sm text-red-700">Dislikes: <b>{{ m.weekly.dislikes }}</b></div>
                    <div class="text-sm text-blue-700">Aprobación: <b>{{ m.weekly.approvalRate | number:'1.0-1' }}%</b>
                    </div>
                </div>

                <div class="rounded-lg border border-gray-200 p-3 bg-gray-50">
                    <div class="text-xs uppercase tracking-wide text-gray-500">Mensual</div>
                    <div class="mt-2 text-sm text-slate-700">Votos: <b>{{ m.monthly.totalVotes }}</b></div>
                    <div class="text-sm text-green-700">Likes: <b>{{ m.monthly.likes }}</b></div>
                    <div class="text-sm text-red-700">Dislikes: <b>{{ m.monthly.dislikes }}</b></div>
                    <div class="text-sm text-blue-700">Aprobación: <b>{{ m.monthly.approvalRate | number:'1.0-1' }}%</b>
                    </div>
                </div>
            </div>

            <div class="rounded-lg border border-gray-200 p-3 bg-(--stela-surface)">
                <div class="text-sm font-semibold text-slate-800 mb-2">Top preguntas con dislike</div>
                <div *ngIf="m.topDislikedIntents.length === 0" class="text-sm text-gray-500">
                    No hay datos suficientes.
                </div>
                @for (item of m.topDislikedIntents; track $index; let idx = $index) {
                <div class="py-2 border-b border-gray-100 last:border-b-0">
                    <div class="text-xs text-gray-400">#{{ idx + 1 }} · {{ item.count }} votos negativos</div>
                    <div class="text-sm text-slate-700 wrap-break-word">{{ item.question }}</div>
                </div>
                }
            </div>
        </ng-container>
    </div>

    <!-- Chat View -->
    <ng-container *ngIf="view() === 'chat'">
        <!-- Messages Area -->
        <div #scrollContainer class="flex-1 overflow-y-auto p-4 space-y-4 bg-(--stela-surface)">
            <div *ngIf="chatService.messages().length === 0" class="text-center mt-10 px-4">
                <i class="pi pi-bolt text-4xl mb-3 text-blue-400"></i>
                <p class="text-gray-600 mb-4">¿En qué puedo ayudarte?</p>
                <div class="flex flex-wrap gap-2 justify-center">
                    @for (sp of suggestedPrompts(); track $index) {
                    <button
                        class="px-3 py-2 bg-blue-50 text-blue-700 rounded-full text-xs hover:bg-blue-100 transition-colors border border-blue-200"
                        (click)="useSuggestedPrompt(sp)">
                        {{ sp }}
                    </button>
                    }
                </div>
            </div>

            @for (msg of chatService.messages(); track msg.id) {
            <div
                [ngClass]="{'items-end': msg.role === 'user', 'items-start': msg.role === 'assistant'}"
                class="flex flex-col mb-4 group">

                <div [ngClass]="{'bg-blue-600 text-white rounded-br-none': msg.role === 'user', 'bg-gray-100 text-slate-800 rounded-bl-none': msg.role === 'assistant'}"
                    class="max-w-[85%] p-3 rounded-xl shadow-xs text-sm leading-relaxed wrap-break-word border border-transparent markdown-content"
                    [class.border-gray-200]="msg.role === 'assistant'" [innerHTML]="msg.content | markdown"
                    (click)="handleMessageClick($event)">
                </div>

                <!-- Action Proposal Card -->
                <div *ngIf="msg.pendingAction" class="max-w-[85%] mt-2 p-3 rounded-xl border text-sm" [ngClass]="{
                        'border-amber-300 bg-amber-50': msg.pendingAction.status === 'pending',
                        'border-blue-300 bg-blue-50': msg.pendingAction.status === 'approved',
                        'border-green-300 bg-green-50': msg.pendingAction.status === 'executed',
                        'border-gray-300 bg-gray-50': msg.pendingAction.status === 'denied',
                        'border-red-300 bg-red-50': msg.pendingAction.status === 'error'
                    }">
                    <div class="flex items-center gap-2 mb-2">
                        <i class="pi pi-bolt text-amber-500"></i>
                        <span class="font-semibold text-sm text-slate-800">{{ msg.pendingAction.displayName }}</span>
                    </div>

                    <p class="text-xs text-gray-600 mb-2">{{ msg.pendingAction.description }}</p>

                    <!-- Parameters -->
                    <div *ngIf="msg.pendingAction.parameters.length > 0" class="space-y-1 mb-3">
                        @for (p of msg.pendingAction.parameters; track $index) {
                        <div class="flex gap-2 text-xs">
                            <span class="text-gray-500">{{ p.label }}:</span>
                            <span class="font-medium text-slate-700">{{ p.value }}</span>
                        </div>
                        }
                    </div>

                    <!-- Pending: Approve / Deny / Always Allow -->
                    <div *ngIf="msg.pendingAction.status === 'pending'" class="flex flex-wrap items-center gap-2">
                        <p-button label="Aprobar" icon="pi pi-check" size="small" severity="success"
                            (onClick)="approveAction(msg)"></p-button>
                        <p-button label="Denegar" icon="pi pi-times" size="small" severity="danger" [outlined]="true"
                            (onClick)="denyAction(msg)"></p-button>
                        <div class="flex items-center gap-1 ml-1">
                            <p-checkbox [binary]="true" inputId="aa-{{msg.id}}"
                                (onChange)="toggleAlwaysAllow(msg.pendingAction!.actionType, $event.checked)">
                            </p-checkbox>
                            <label for="aa-{{msg.id}}" class="text-xs text-gray-500 cursor-pointer">Permitir
                                siempre</label>
                        </div>
                    </div>

                    <!-- Approved (loading) -->
                    <div *ngIf="msg.pendingAction.status === 'approved'" class="text-xs text-blue-600">
                        <i class="pi pi-spin pi-spinner mr-1"></i> Ejecutando...
                    </div>

                    <!-- Executed: Success -->
                    <div *ngIf="msg.pendingAction.status === 'executed'" class="text-xs text-green-700">
                        <i class="pi pi-check-circle mr-1"></i> {{ msg.pendingAction.resultMessage }}
                    </div>

                    <!-- Denied -->
                    <div *ngIf="msg.pendingAction.status === 'denied'" class="text-xs text-gray-500">
                        <i class="pi pi-ban mr-1"></i> Accion denegada.
                    </div>

                    <!-- Error -->
                    <div *ngIf="msg.pendingAction.status === 'error'" class="text-xs text-red-600">
                        <i class="pi pi-exclamation-circle mr-1"></i> {{ msg.pendingAction.resultMessage }}
                    </div>
                </div>

                <div class="flex items-center gap-2 mt-1">
                    <span class="text-xs text-gray-400">{{ msg.timestamp | date:'shortTime' }}</span>
                    <div *ngIf="msg.role === 'assistant' && msg.content"
                        class="flex gap-1 opacity-100 transition-opacity">
                        <button *ngIf="hasSteps(msg.content)"
                            class="text-xs text-blue-500 hover:text-blue-700 w-6 h-6 flex items-center justify-center rounded-sm hover:bg-blue-50"
                            (click)="startGuide(msg.content)" title="Iniciar recorrido">
                            <i class="pi pi-play text-[10px]"></i>
                        </button>
                        <button
                            class="text-xs text-gray-400 hover:text-gray-600 w-6 h-6 flex items-center justify-center rounded-sm hover:bg-gray-100"
                            (click)="copyMessage(msg)" title="Copiar">
                            <i class="pi pi-copy text-[10px]"></i>
                        </button>
                        <button class="text-xs w-6 h-6 flex items-center justify-center rounded-sm hover:bg-gray-100"
                            [ngClass]="msg.feedback === 'like' ? 'text-green-500' : 'text-gray-400 hover:text-green-500'"
                            (click)="rateMessage(msg.id, 'like')" title="Me gusta">
                            <i class="pi" [ngClass]="msg.feedback === 'like' ? 'pi-thumbs-up-fill' : 'pi-thumbs-up'"
                                style="font-size: 10px;"></i>
                        </button>
                        <button class="text-xs w-6 h-6 flex items-center justify-center rounded-sm hover:bg-gray-100"
                            [ngClass]="msg.feedback === 'dislike' ? 'text-red-500' : 'text-gray-400 hover:text-red-500'"
                            (click)="rateMessage(msg.id, 'dislike')" title="No me gusta">
                            <i class="pi"
                                [ngClass]="msg.feedback === 'dislike' ? 'pi-thumbs-down-fill' : 'pi-thumbs-down'"
                                style="font-size: 10px;"></i>
                        </button>
                        <button *ngIf="msg === lastAssistantMessage()"
                            class="text-xs text-gray-400 hover:text-gray-600 w-6 h-6 flex items-center justify-center rounded-sm hover:bg-gray-100"
                            (click)="retryLastMessage()" title="Reintentar">
                            <i class="pi pi-refresh text-[10px]"></i>
                        </button>
                    </div>
                </div>
            </div>
            }

            <div *ngIf="chatService.isLoading()" class="flex flex-col items-start mb-4">
                <div class="bg-gray-100 p-3 rounded-xl rounded-bl-none animate-pulse border border-gray-200">
                    <div class="flex gap-1">
                        <div class="w-2 h-2 bg-gray-400 rounded-full animate-bounce"></div>
                        <div class="w-2 h-2 bg-gray-400 rounded-full animate-bounce delay-75"></div>
                        <div class="w-2 h-2 bg-gray-400 rounded-full animate-bounce delay-150"></div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Input Area -->
        <!-- Input Area -->
        <div class="input-area p-4 border-t border-gray-200 bg-gray-50">
            <div
                class="bg-(--stela-surface) border border-gray-300 rounded-xl shadow-xs focus-within:border-blue-500 focus-within:ring-1 focus-within:ring-blue-500 transition-all overflow-hidden flex flex-col">
                <textarea #textarea pInputTextarea [(ngModel)]="prompt" (keydown.enter)="handleKeydown($event)"
                    (input)="handleInput($event)" rows="3" [placeholder]="'chat.message_placeholder' | translate"
                    class="w-full bg-transparent border-none text-slate-800 pl-3 pr-3 py-3 resize-none focus:ring-0 focus:outline-hidden min-h-[80px] max-h-[200px]"
                    autoResize="true">
                </textarea>

                <div class="flex justify-between items-center p-2 bg-gray-50 border-t border-gray-100">
                    <div class="flex items-center">
                        <p-select [options]="chatModes()" [ngModel]="chatMode()" (ngModelChange)="onModeSelect($event)" optionLabel="label" optionValue="value"
                            size="small" [style]="{'border':'none', 'background':'transparent', 'box-shadow':'none'}"
                            styleClass="text-xs font-medium text-gray-600 hover:bg-gray-200 rounded-md transition-colors"
                            appendTo="body">
                        </p-select>
                        <p-button *ngIf="canConfigureTools()" icon="pi pi-wrench" [rounded]="true" [text]="true"
                            styleClass="text-gray-600 hover:text-gray-900 hover:bg-gray-200 w-8 h-8 ml-1"
                            (onClick)="toolsOp?.toggle($event)"></p-button>
                    </div>
                    <p-button icon="pi pi-send" [rounded]="true" [text]="true"
                        styleClass="text-blue-600 hover:text-blue-800 hover:bg-blue-50 w-8 h-8 flex items-center justify-center transition-colors"
                        [disabled]="!prompt.trim() || chatService.isLoading()" (onClick)="sendMessage()">
                    </p-button>
                </div>
            </div>

            <p-popover #toolsOp appendTo="body">
                <div class="w-72 p-2">
                    <div class="text-xs font-semibold text-slate-700 mb-2">Herramientas disponibles</div>
                    <div *ngIf="availableToolPlugins().length === 0" class="text-xs text-gray-500 py-1">
                        No hay herramientas para este usuario.
                    </div>
                    <div class="max-h-60 overflow-y-auto">
                        @for (plugin of availableToolPlugins(); track plugin.name) {
                        <div class="flex items-center justify-between py-1 gap-2 border-b border-gray-100 last:border-0 hover:bg-gray-50 transition-colors pr-2">
                            <div class="min-w-0 flex-1">
                                <div class="text-xs font-medium text-slate-800 truncate" [title]="plugin.name">{{
                                    plugin.name }}</div>
                                <div class="text-[10px] text-gray-500">{{ plugin.functionCount }} methods</div>
                            </div>
                            <p-checkbox [binary]="true" [ngModel]="isToolPluginEnabled(plugin.name)"
                                (onChange)="toggleToolPlugin(plugin.name, $event.checked)">
                            </p-checkbox>
                        </div>
                        }
                    </div>
                </div>
            </p-popover>

            <p-popover #mentionOp>
                <div class="w-64 p-0">
                    <p-listbox [options]="mentionResults()" optionLabel="display"
                        [style]="{'border':'none', 'padding':'0'}" (onClick)="selectEntity($event.value)"
                        [listStyle]="{'max-height': '200px'}">
                        <ng-template let-entity pTemplate="item">
                            <div class="flex flex-col w-full">
                                <span class="font-bold text-sm">{{entity.display}}</span>
                                <span class="text-xs text-gray-500">{{entity.entity}}</span>
                            </div>
                        </ng-template>
                    </p-listbox>
                </div>
            </p-popover>

            <div class="text-xs text-gray-400 mt-2 text-center">
                La IA puede cometer errores. Verifica la información importante.
            </div>
        </div>
    </ng-container>
</div>